.ribbon {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 23px;
  max-width: 100%;
}

.card {
  flex: 1 1 0;
  min-width: 0;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1.5px solid rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.25);
  color: var(--rs-text-on-primary, #fff);
  cursor: pointer;
  font-family: inherit;
  text-align: center;
  outline: none;
  transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.35);
    border-color: rgba(255, 255, 255, 0.7);
  }

  &.active {
    background: rgba(255, 255, 255, 0.92);
    color: var(--rs-theme);
    border-color: rgba(255, 255, 255, 0.92);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  }
}

.title {
  display: block;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}